import { useQuery } from "@tanstack/react-query";
import { getSymptoms } from "../api/symptoms.api";
import { SymptomRow } from "../api/symptom.type";
import { useUserDetails } from "./useUserDetails";

function useLoadSymptoms(userId?: string) {
  const { userDetails } = useUserDetails();
  const resolvedUserId = userId || userDetails?.id;

  const {
    data: symptoms = [],
    isLoading,
    error,
  } = useQuery<SymptomRow[]>({
    queryKey: ["symptoms", resolvedUserId],
    queryFn: () => getSymptoms(userId ? userId : undefined),
    enabled: Boolean(resolvedUserId),
    select: (data) => (Array.isArray(data) ? data : []),
  });

  return { symptoms, isLoading, error };
}

export default useLoadSymptoms;
